import React, { useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { Button } from '../_shared';
import ArrowRightIcon from '../../assets/icons/arrow-right';
import 'react-circular-progressbar/dist/styles.css';
import { ThemeContext } from '../../providers/ThemeProvider';
import { makeSelectIsIcscOrg } from '../../store/selectors';
import { Container, ProgressBar } from './Curriculum.styled';

const Curriculum = ({ hasStarted, curriculum, progress, onResume }) => {
  const { primaryColor } = useContext(ThemeContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isIframe = searchParams.get('iframe');
  const isIcscOrg = useSelector(makeSelectIsIcscOrg());

  const percent = useMemo(() => {
    const totalPercent = curriculum.courses.reduce((p, c) => {
      const userCourse = progress.find(
        ({ course: coourse }) => coourse && coourse._id === c._id
      );

      if (userCourse) {
        const total =
          userCourse.course.lessons.length + userCourse.course.quizzes.length;
        const current =
          userCourse.completedLessons.length +
          userCourse.completedQuizzes.length;
        return p + Math.min(100, (current / total) * 100);
      } else {
        return p;
      }
    }, 0);
    return Math.floor(parseFloat(totalPercent) / curriculum.courses.length);
  }, [curriculum, progress]);

  return (
    <Container bg={primaryColor} isIcsc={!isIframe && isIcscOrg}>
      {!isIframe && isIcscOrg && <div className="overlay" />}
      <div className="content">
        <div className="text-white uppercase title text-center">
          {curriculum.title}
        </div>
        <div className="text-white text-center content-text">
          {curriculum.description}
        </div>
        {hasStarted && (
          <ProgressBar>
            {/* <div className="progress mt-4">
              <ProgressBar value={percent} />
            </div>
            <div className="text-white text-base mt-1">{percent}% Complete</div> */}
            <CircularProgressbar
              value={percent}
              text={`${Number(percent)}%`}
              strokeWidth={5}
              styles={buildStyles({
                textColor: '#fff',
                textSize: '16px',
                pathColor: '#fff',
                trailColor: 'rgba(255, 255, 255, 0.1)',
              })}
            />
          </ProgressBar>
        )}
        <Button
          type="misc"
          className="w-56 sm:w-full py-3 px-9 bg-light-yellow rounded-lg text-white mt-8 font-bold"
          caption={
            hasStarted ? (
              <>
                Continue
                <ArrowRightIcon className="ml-2" />
              </>
            ) : (
              'Start'
            )
          }
          onClick={onResume}
        />
      </div>
    </Container>
  );
};

export default Curriculum;
